module.exports = __webpack_public_path__ + "img/ic_happix_w.e54d87e.svg";